import useMineSweeper from "./useMineSweeper";

type GameProps = {
  zoom: number;
  sound: boolean;
  size: number;
  bombs: number;
};

const CELL_SIZE = 24;
const Game: React.FC<GameProps> = ({
  zoom = 1,
  sound,
  size = 8,
  bombs = 8
}) => {
  const { grid, gameStatus, timerValue, blockRender, startGame } =
    useMineSweeper(CELL_SIZE * zoom, sound, size, bombs);

  return (
    <div
      className='minesweeper-game-container'
      style={
        { "--border-width": `${CELL_SIZE * zoom * 0.1}px solid` } as Record<
          string,
          string
        >
      }
      onContextMenu={e => e.preventDefault()}>
      <div
        className='main-hud'
        style={{
          width: `calc(${CELL_SIZE * zoom}px * ${grid.length} + ${
            CELL_SIZE * zoom * 0.2
          }px)`
        }}>
        <div className='lcd-digits'>
          <p className='back'>888</p>
          <p>
            {String(
              gameStatus.minesCount - gameStatus.flagsCount || 0
            ).padStart(3, "0")}
          </p>
        </div>
        <button className='button square' onClick={startGame}>
          {gameStatus.buttonEmoji}
        </button>
        <div className='lcd-digits'>
          <p className='back'>888</p>
          <p>{String(timerValue || 0).padStart(3, "0")}</p>
        </div>
      </div>
      <div
        className='main-frame'
        style={{
          width: `calc(${CELL_SIZE * zoom}px * ${grid.length} + ${
            CELL_SIZE * zoom * 0.2
          }px)`
        }}>
        {grid?.map(
          (col, x) =>
            col &&
            col.length > 0 &&
            col.map((_, y) => (
              <div
                key={`${x}-${y}-cell`}
                className='cell'
                style={{ width: CELL_SIZE * zoom, height: CELL_SIZE * zoom }}>
                {blockRender(x, y)}
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default Game;
